export default {

    'Invoices': 'Invoices',
    'Sent': 'Clients',
    'Received': 'Providers',
    'Cancel': 'Cancel',
    'CANCEL': 'CANCEL',
    'to accept or deny this bypay.': 'to accept or reject this byppay.',
    'has denied this bypay.': 'has rejected this byppay.',
    'This bypay has been approved by': 'This byppay has been approved by',
    'is asking you to simplify the next invoices:': 'is asking you to compensate these invoices:',
    'offers you to change the next invoice:': 'offers you to compensate this invoice:',
    'offers to pay you the next invoice:': 'offers a client to pay this invoice directly to you:',
    'payProvider': 'You will use a client\'s invoice to pay up to {invoicePrice} € to this provider. Proceed?',
    'payClient': 'You will use this invoice up to {invoicePrice} € from a client to pay a provider, is it ok?',
    'The Bypay has been approved for everyone, the following information show how the initial invoices have been affected:': 'The byppay has been approved by every party. The following information shows how the invoices will be compensated:',
    'The Bypay has been approved for everyone:': 'The byppay has been approved by every party:',
    'The following information show how the initial invoices have been affected:': 'The following information shows how the invoices will be compensated:',
    'Bypay deleted successfully!': 'Byppay deleted successfully!',
    'Error deleting bypay': 'Error deleting byppay',
    'Do you want to accept this bypay?': 'Do you want to accept this byppay?',
    'Do you want to decline this bypay proposal?': 'Do you reject this byppay proposal?',
    'Do you want to propose your partners this bypay?': 'Do you want to propose this byppay to your client and provider?',
    'Do you want to remove this invoice bypay forever?': 'Do you really want to remove this invoice byppay?',
    'Comision': 'Fee',
    'You let empty params, check it again please': 'You left empty parameters; please, check it again',
    'Waiting for your partner': 'Waiting for your client and provider',
    'when you propose your providers if they want to be paid directly from your clients.': 'when you propose your providers whether they want to be paid directly by your clients.',
    'Bypay': 'Byppay',
    'when you ask your clients to pay your providers or when you want any client of your client to pay directly': 'when you ask your clients to pay your providers or when you want any client of your client to pay directly to you',
    'You cannot use this option due not have a camera device. Use Custom Upload instead!': 'You cannot use this option without having a camera device. Use Custom Upload instead!',
    'Do you want to cancel this bypay?': 'Do you want to cancel this byppay?',
    'Bypay Summary': 'Byppay Summary',
    'Factoring information': 'Byppay information',
    'Don\'t show the splash screen at the beggining': 'Don\'t show the splash screen',
    'USER NOT LOGGED!': 'WELCOME TO BYPPAY',
    'You are not logged into the platform, please login or register to perform some action': 'Please, login o register to fulfil the compensation',

    'finishCompensation.payerFinish': '{payerCif} pays {amount}€ to {receiverCif} to the account {accountNumber}, and recives a discount of {discount}€',
    'finishCompensation.payerPartial': '{payerCif} pays {amount}€ to {receiverCif} to the account {accountNumber},and recives a discount of {discount}€ so the outstanding amount to pay to {oldReceiverCif} is {outstandingAmount}€.',
    'finishCompensation.receiverFinish': 'You have to receive {amount}€ from {receiverCif} in the account {accountNumber}, So you get a bonus of {bonus}€',
    'finishCompensation.receiverPartial': 'You have to receive {amount}€ from {receiverCif} in the account {accountNumber},so you get a bonus of {bonus}€ and you will receive an amount of {outstandingAmount}€ of {payerCif}.',
    'finishCompensation.middlePayer': '{payerCif} will pay his invoice directly to {receiverCif} , You still have to pay an amount of {outstandingAmount} from {receiverCif}',
    'finishCompensation.middleReceiver': '{payerCif} will pay his invoice directly to {receiverCif} , You will receive an amount of {outstandingAmount} from {payerCif}',
    'certificate.middle': 'B acknowledges that A by paying C compensates {amount} euro/s from the invoice AB [{invoiceNumberAB} - ',
    'certificate.middle2': '] that is annotated with the compensation ',
    'certificate.receiver': 'C acknowledges that with this payment from A {amount} euro/s are compensated from the BC invoice [{invoiceNumberBC} - ',
    'certificate.receiver2': '], which is annotated in this way ',
    'certificate.payer': 'A acknowledges that with this payment receives a {amount} euro/s byppay included in AB compensation.',
    'certificate.middleP2': 'up to {amount} euro to `pay C',
    'certificate.receiverP2': 'and receive {amount} euro as late interest',
    'certificate.outstanding': 'B acknowledges that {amount} of the invoice {invoiceName} will remain to be paid ',

    'payment.confirmPaymentto': 'Confirm the payment to {user}.',
    'payment.confirmPaymenStripeto': 'Pay with stripe to {user}.',
    'payment.confirmPaymento': 'Pay to {user}.',
    'payment.confirmPaymentFrom': 'Confirm the payment from {user}.',
    'payment.acceptPaymentFrom': '{user} has accepted the payment.',
    'payment.acceptPayment': 'You have accepted the payment.',
    'payment.waitingPaymentFrom': 'Waiting {user} to pay.',
    'payment.waitingConfirmationto': 'Waiting {user} to confirm your payment.',
    'payment.payiedto': 'I paid to {user}',
    'payment.receivedFrom': 'I received the {user} payment',
    'from': 'from',
    'REMAIN': 'REMAIN',
    'Pay': 'Pay',
    'to': 'to',
    'Invoices list': "Invoices",
    'You not have Candidates!': 'You have no candidate invoices available!',
    'InvoiceChats.No messages in chat': 'No messages in this chat',
    'InvoiceChats.My chats': 'My chats',
    'Comission for the payer': 'Discount for the payer',
    'Desired comission for the payer': 'Desired discount for the payer',
    'Payer comission': 'Payer discount',
    'No files avaliable.': 'No files available',
    'Already exists a user with this CIF': 'A user with this CIF already exists',
    'Already exists a user with this Email': 'A user with this email already exists',
    'You cannot post an invoice where you have to pay': 'You cannot post an invoice which you have to pay',
    'Registered succesfully! Please check your email for the validation': 'Registered succesfully! Please check your email for the validation',
    'Add liquidity': 'Add liquidity',
    'Message Add Liquidity': 'Amount of liquidity to be provided',
    'Wallet Address': 'Wallet Address',
    'Payment with stripe:': 'Payment with stripe:',
    'Deleted of list': 'Deleted from the list',
    'Add to list': 'Add to list',
    'Publish invoice to marketplace': 'Publish invoice to marketplace',
    'Initial Amount': 'Initial Amount',
    'Anonymous': 'Anonymous',
    'View invoice': 'View invoice',
    'Approve byppayes': 'Approve byppays',
    'Pay with crypto': 'Pay with crypto',
    'I payed outside of platform': 'I payed outside the platform',
    'Success changing the payment status': 'Success changing the payment status',
    'Error changing the payment status': 'Error changing the payment status',
    'Select allowed payment methods': 'Select allowed payment methods',
    'Byppay Commision': 'Byppay Commision',
    'Email publish': 'publish invoice to marketplace',
    'Minimum value to pay': 'Minimum value to pay: ',
    'Email list notification': 'List of emails to notify the publication on the market. The emails must be separetd by commas.',
    'Percentage user commision': 'User fee (in percentage)',
    'Percentage platform commision': 'Platform fee (in percentage)',
    'Return amount': 'Return amount',
    'Return collateral': 'Return collateral',
    'Publish to marketplace': 'Publish on the marketplace',
    'Error: pay collateral': 'Error: pay collateral',
    'Collateral payed': 'Collateral paid',
    'Collateral amount': 'Collateral amount',
    'Colect collateral': 'Collect collateral',
    'Platform amount': 'Collect collateral',
    'Invoices to pay': 'Invoices to pay',
    'Invoices to be payed': 'Invoices to get paid',
    'Clients': 'Clients',
    'Marketplace': 'Marketplace',
    'AMM': 'rkAMM',
    'Pay commissions with bytos?': 'Pay fees in Byto?',
    'Min Date': 'Min Date',
    'Min Amount': 'Min Amount',
    'Min-Max Amount': 'Min-Max Amount',
    'Introduce Min and Max Date': 'Introduce Min and Max Date',
    'Advanced Options': 'Advanced Options',
    'Reset': 'Reset',
    'Archived': 'Archived',
    'Byppay Now': 'Byppay Now!',
    'Record Video': 'Record Video',
    'Filter': 'Filter',
    'Faq': 'FAQ',
    'Chat': 'Chat',
    'Choose an invoice': 'Choose an invoice',
    'Invite': 'Invite',
    'Invited': 'Invited',
    'Upload Candidate': 'Add invoice',
    'GO': 'Go',
    'Upload Invoice': 'Upload Invoice',
    'Back': 'Back',
    'INVOICE NUMBER': 'INVOICE NUMBER',
    'Invoice Number': 'Invoice number',
    'Due Date': 'Due Date',
    '+ Add Contact': '+ Add Contact',
    'Amount': 'Amount',
    'AMOUNT': 'AMOUNT',
    'Participant': 'Participant',
    'Save': 'Save',
    'or': 'o',
    'NIE/NIF': 'VAT number',
    'Password': 'Password',
    'LOG IN': 'LOG IN',
    'SIGN UP': 'Sign up',
    'ERROR: Something went wrong': 'ERROR: Something went wrong',
    'E-mail': 'Email',
    'Phone number': 'Phone number',
    'From: ': 'From: ',
    'To:': 'To:',
    'Logout': 'Logout',
    'Outstanding Amount': 'Outstanding Amount',
    'DATE': 'DATE',
    'Date': 'Date',
    'Delay': 'Delay',
    'Payer': 'Payer',
    'Receiver': 'Receiver',
    'OK': 'OK',
    'The invoice number you have entered already exists': 'The invoice number you have entered already exists!',
    'The phone must be valid': 'The phone must be valid',
    'The mail must be valid.': 'he mail must be valid',
    'This certificate reflects the agreement executed by the three parties': 'This certificate reflects the agreement executed by the three parties',
    ' will pay an amount of ': ' will pay an amount of ',
    'Factoring information:': 'Byppay information',
    'Compensation': 'Compensation',
    'Payer invoice:': 'Payer invoice:',
    'Receiver invoice:': 'Receiver invoice:',
    'Please enter the email of the user: ': 'Please enter the email of the user: ',
    'Tell me what type of invoice is': 'Tell me what type of invoice is',
    'Close': 'Close',
    'CLOSE': 'CLOSE',
    'View transaction': 'View transaction',
    'ConfirmationModal.Yes': 'Yes',
    'The value field is required': 'The value field is required',
    'The phone field is required': 'The phone field is required',
    'Comission must be greater than 0': 'Fee must be larger than 0',
    'Petition rejected': 'Petition is rejected',
    'Remaining to pay:': 'Remaining payment: ',
    'Remaining to receive:': 'Remaining income: ',
    'Your partner': 'Your client',
    'User': 'User',
    'No more payments required!': 'No more payments required!',
    'You pay': 'You pay',
    'will pay': 'will pay',
    'You receive': 'You receive',
    'all': 'all',
    'partners!': 'the parties!',
    'Accepted': 'Accepted',
    'COMPARATIVE INVOICES': 'COMPARATIVE INVOICES',
    'INVOICE NUMBER ': 'INVOICE NUMBER ',
    'New Payer: ': 'New Payer: ',
    'New Receiver: ': 'New Receiver: ',
    'New Amount: ': 'New Amount: ',
    'Catalan': 'Catalan',
    'Spanish': 'Spanish',
    'English': 'English',
    'Accept': 'Accept',
    'Confirm': 'Confirm',

    'Number:': 'Numnber ',
    'Payer CIF:': 'VAT num. of the Payer: ',
    'ShowInvoiceInformation.New Payer cif: ': 'New VAT num. Payer: ',
    'Receiver CIF:': ' VAT num. of the Receiver: ',
    'ShowInvoiceInformation.New Receiver cif: ': 'New VAT num. of the Receiver: ',
    'Download': 'Download',
    'DOWNLOAD': 'DOWNLOAD',
    'ERROR: The invoice couldn\'t be saved, try again': 'ERROR: The invoice couldn\'t be saved, try again',
    'ERROR: Invoice number already exists': 'ERROR: Invoice number already exists',
    'Saved successfully!': 'saved successfully',
    'Error paying invoice': 'Error paying the invoice',
    'Invoice payed successfully!': 'Invoice paid successfully',
    'Do you want to delete this invoice?': 'o Are you sure to delete this invoice?',
    'Confirmation': 'Confirmation',
    'Refreshing...': 'Refreshing...',
    'Refreshing..': 'Refreshing..',
    'My NIF/CIF': 'My VAT number',
    'Missing Data': 'FMissing Data',
    'Login': 'Login',
    'Client': 'Client',
    'CLIENT': 'CLIENT',
    'Account number': 'Account number',
    'ACCOUNT NUMBER': 'ACCOUNT NUMBER',
    'is going to pay this invoice to you by asking his client to do it: ': 'eis going to pay this invoice to you by asking his client to do it',
    'EMAIL': "EMAIL",
    'You must enter the email of the ': 'ou must enter the email of the ',
    'receiver!': 'receiver!',
    'payer!': 'payer!',
    'Email': 'Email',
    'Rossum have detected the next information:': 'Rossum have detected the following information:',
    'Do you want to import?(in the next screen you can modify the fields)': "Do you want to import?(in the next screen you can modify the fields)",
    'Import information?': 'Import information?',
    'Click on the contact to send the message via SMS and check the box': 'Click on the contact to send the message via SMS and check the box',
    'Click on the contact to send the message via Whatsapp and check the box': 'Click on the contact to send the message via WhatApp and check the box',
    'Phone of ': 'Phone of ',
    'Notification options': 'Notification options',
    'How do you want to notify compensation?': 'How do you want to notify compensation?',
    'is a platform that facilitates payments to providers through potential customers in a fast, economical and secure way': 'is a platform that facilitates payments to providers through potential customers in a fast, economic, and secure way',
    'UPLOAD INVOICE': 'UPLOAD INVOICE',
    'Register to byppay.com': 'Sign up for byppay.com',
    'PAY YOUR INVOICES WHEN NO CASH': 'PAY YOUR INVOCIES WITH NO CASH',
    'Dark': 'Dark',
    'Log in': 'Log in',
    'Sign Up': 'Sign Up',
    'Facebook Log in': 'Facebook Login',
    'Google Log in': 'Google Login',
    'I am waiting for your decision. Please go to this link to make an action: ': 'I am waiting for your decision. Please go to this link to make an action:',
    'In order to do this option you need to login, Do you want to login?': 'To do this option you need to login, Do you want to login?',
    'RECEIVER INVOICE': 'RECEIVER INVOICE',
    'To pay': 'To pay',
    '|Policies': '|Polícies',
    'Outstanding amount': 'Outstanding amoun',
    'Delete': 'Delete',
    'OUTSTANDING AMOUNT': 'OUTSTANDING AMOUNT',
    'Certificate number': 'Certificate number',
    'Debtor (A)': 'Debtor (A)',
    'Creditor (B)': 'Creditor (B)',
    'Beneficiary (C)': 'Beneficiary (C)',
    'Manifested agreement': 'Byppay agreement Summary',
    'Payment Accepted': 'Payment Accepted',
    'Record a video for your partners': 'Record a video to invite your partners',
    'Skip': 'Skip',
    'NotificationTypesForCompensate.DON\'T NOTIFICATE': 'DON\'T NOTIFICATE',
    'Quantity that A deduces from his debt with B through a payment to C': 'Quantity that A deduces from his debt with B through a payment to C',
    'Payment from debtor (A) to beneficiary (C)': 'Payment from (A) to beneficiary (C)',
    'To the following account': 'To the following account',
    'From': 'From',
    'To': 'To',



    'Error.User not found': 'User not found',
    'Error.Something went wrong': 'Something went wrong',
    'CompensationSteper.Select allowed payment methods': 'Select allowed payment methods',








    'InvoiceChats.Welcome back': 'Welcome back!',
    'InvoiceChats.There are no chats created yet': 'There is no chat created at the moment.',
    'InvoiceChats.InviteContacts': 'Pay your invoices or receive payments using the “+” button.',

    'chat.remind-paymentMethod': '{user} reminded {userReminded} to add the payment information',
    'chat.remind-to-pay': ' Remind to pay',
    'chat.file-input': 'File input',
    'chat.add-file': 'Add file',
    'Send MAIL': 'Send EMAIL',
    'Send SMS': 'Send SMS',
    'Send Whatsapp': 'Send Whatsapp',

    'EditContact.SAVE': 'SAVE',

    'Payment.crypto': 'Pay with crypto',
    "admin.NETWORK_ERROR": 'Network missmatch',
    "admin.Comissions": 'Platform comissions',
    "admin.EditableMessages": 'Edit messages',
    "admin.Exchange": 'Manage exchange',
    "exchange.NoTransactions": 'There are no transactions',
    "Exchage": "Exchange",
    "Send": "Pay invoice",
    "Receive": "Receive payment",
    "Notifications": "Notifications",
    "What we do?": "What do you want to do? ",
    "Settings": "Settings",
    "Contact us": "Contact us",


    'PaymentChatcomponent.Pay to ': 'Pay to ',

    'Formulary.SENT (to collect)': 'SENT (to earn)',
    'Formulary.RECEIVED (to pay)': 'RECEIVED (to pay)',
    'Formulary.You cannot post an invoice where you have to pay': 'You cannot post an invoice where you have to pay',

    'Create.day': 'day',

    'SuggestedFactoringItem.Email ': 'Email ',

    'Faucet.AlreadySent': 'Money is sent, today',

    'ByppaySummary.Bypay Summary': 'Summary of the Byppay',
    'ByppaySummary,CERTIFICATE': 'CERTIFICATE',
    'ByppaySummary.The Bypay has been approved for everyone:': 'The byppay has been approved by everyone:',
    'ByppaySummary.PAYER INVOICE': 'PAYER INVOICE',

    'FactoringInformation.Factoring information': 'Information of the byppay',



    'Payment accepted': 'Payment accepted',
    'Payment received': 'Payment received',

    'ImageInvoice.Value': 'Value',
    'ImageInvoice.Provider NIF/CIF': 'Provider VAT number',
    'ImageInvoice.Client NIF/CIF': 'Client VAT number',
    'ImageInvoice.Invoice Update Successfully': 'Invoice uploaded correctly',
    'ImageInvoice.Invoice Date': 'Invoice Date',
    'ImageInvoice.Save Invoice': 'SAVE INVOICE',
    'ImageInvoice.You cannot use this option due not have a camera device. Use Custom Upload instead!': 'You cannot use this option because you have not any camera. Use Custom Upload instead!',
    'ImageInvoice.Retry': 'Retry',
    'ImageInvoice.UPLOAD': 'UPLOAD',

    'ListInvoicesForCompensate.Candidate invoice for the Forward:': 'Candidate invoices for the factoring byppay ',

    'ListInvoices.Provider': 'Provider',
    'ListInvoices.Receiver email:': 'Receiver\'s email',
    'ListInvoices.Have to be a number': 'A number is required',

    'InvoiceView.Invoice not found': 'Invoice not found',
    'InvoiceView.Do you want to cancel this bypay?': 'Are you sure you want to cancel this byppay',
    'InvoiceView.ERROR: Non-editable invoice': 'Non-editable invoice',
    'InvoiceView.Invalid status change': 'Invalid status change',
    'InvoiceView.Return amount': 'Amount to return',
    'InvoiceView.Fullscreen': 'Full screen',

    'Factoring.I ': 'I have ',
    'Factoring.accepted the Byppay!': 'accepted the byppay!',
    'Factoring.The final state of the bypay is:': 'The final state of the byppay is:',
    'Factoring.rejected the Byppay!': 'rejected the Byppay!',
    'Factoring.Summary': 'Summary',
    'Factoring.Waiting': 'Waiting',
    'Factoring.Do you want to reject this bypay?': 'Do you want to reject this byppay?',

    'RemindOptions.Notify Via...': 'Notify Through...',
    'RemindOptions.If necessary, enter the phone number to send a SMS notification.': 'If necessary, enter the phone number to send a SMS notification.',
    'RemindOptions.If necessary, enter the phone number to send a Whatsapp notification.': 'If necessary, enter the phone number to send a WhatsApp notification.',
    'RemindOptions.Reminded successfully': 'Reminded successfully',

    'LandingPage.KNOW MORE': 'KNOW MORE',
    'LandingPage.WHAT IS BYPPAY?': 'QHAT IS BYPPAY?',
    'LandingPage.Upload your invoices': 'Upload your invoices',
    'LandingPage.Choose which of the invoices your customers will pay your providers': 'Choose which invoices your clients be paying to your providers',
    'LandingPage.Once accepted, you will get your certificate': 'Once accepted, you will get your certificate',
    'LandingPage.Check your compensations': 'Check your compensations',
    'LandingPage.WHY BYPPAY?': 'WHY BYPPAY?',
    'LandingPage.FAST': 'FAST',
    'LandingPage.Thanks to its BlockChain technology, Bypay allows you to create in a few hours a direct payment agreement between customers and providers': 'Thanks to its BlockChain technology, Bypay allows you to create in few hours a direct payment agreement between your clients and providers',
    'LandingPage.ECONOMIC': 'ECONÒMIC',
    'LandingPage.Byppay avoids the consequences of being an intermediary between customer and provider. Byppay does not depend on any bank': 'Byppay avoids the consequences of being an intermediary between clients and provider. Byppay does not depend on any bank',
    'LandingPage.SAFE': 'SAFE',
    'LandingPage.Bypay uses DLT technology to secure payment agreements between customer-provider.': 'BypPay uses DLT technology to secure payment agreements between client and  provider.',
    'LandingPage.WelcomeMessage1' : 'Welcome to Byppay,',
    'LandingPage.WelcomeMessage2' : 'the fastest and most affordable solution for paying invoices.',
    'LandingPage.NoAccount': 'Not registered yet?',
    'LandingPage.Start': 'Let\'s get started!',
    'LandingAC. is a digital system that makes it easier for all those entrepreneurs to pay their providers through potential clients in times of crisis in a fast, cheap and safe way.': 'Byppay is a digital system that makes it easier for all those entrepreneurs to pay their providers through potential clients in times of crisis in a fast, cheap and safe way.',

    'MoreInfo.Upload the invoice to be paid to the web-app': 'Upload the invoice to be paid to the webApp',
    'MoreInfo.HOW IT WORKS?': 'HOW DOES IT WORK?',
    'MoreInfo.Request payment of the invoice to the customer you want': 'Request payment of the invoice to the client you want',
    'MoreInfo.The app automatically negotiates a customer-provider agreement': 'The webApp automatically negotiates a client-provider agreement',
    'MoreInfo.You will receive a payment confirmation when the provider has paid the customer, as well as a certificate proving payment': 'You will receive a payment confirmation when the client has paid the provider, as well as a certificate proving payment',
    'MoreInfo.is a digital platform that works worldwide and is VAT neutral. It allows you not to advance money to your provider without having received your client\'s income. These payments they are registered with DLT (Distribution Ledger Technology) which makes a valid and secure agreement possible.': 'is a digital platform that works worldwide and is VAT neutral. It allows you not to advance money to your provider without having received your client\'s income. These payments they are registered with DLT (Distribution Ledger Technology) which makes a valid and secure agreement possible.',
    'MoreInfo.It is a financial solution that works with Ethereum which makes it a DeFi (Decentralized Finance) solution. By the end of 2021, more than 100,000 European SMEs will avoid bills thanks to the digitization of agreements and payments with DeFi solutions such as': 'És una solució financera que funciona amb Ethereum, cosa que el converteix en una solució DeFi (finançament descentralitzat). A finals del 2024, més de 100.000 pimes europees evitaran les factures gràcies a la digitalització d’acords i pagaments amb solucions DeFi com ara',
    'MoreInfo.An invoice is a commercial document that indicates the sale of a good or service and that, among other things, must include all the information of the operation. It has legal and fiscal validity. We can say that it is an accreditation of a transfer of a product or service after purchasing it.': 'An invoice is a commercial document that indicates the sale of a good or service and that, among other things, must include all the information of the operation. It has legal and fiscal validity. We can say that it is an accreditation of a transfer of a product or service after purchasing it.',
    'MoreInfo.What is an invoice?': 'What is an invoice?',
    'MoreInfo.What is a byppay?': 'What is a byppay?',
    'MoreInfo.Through the bypay mechanism, a company can pay the invoices to its suppliers with the invoices of its clients.': 'Through the byppay mechanism, a company can pay the invoices to its suppliers with the invoices of its clients',
    'MoreInfo.It is the reverse procedure to bypay, through which a company invoices from clients (to be collected) can be sent to our suppliers to pay their invoices.': 'It is the reverse procedure to byppay, through which a company invoices from clients (to be collected) can be sent to the company\'s suppliers to pay their invoices.',
    'MoreInfo.The main benefit that the company obtains when executing this operation is to offset invoices. This, by extension, improves the financing capacity of the business.': 'The main benefit that the company obtains when executing the byppay operation is to offset invoices. This, by extension, improves the financing capacity of the business.',
    'MoreInfo.It is the technology that ensures that the actions related to a bypay / factoring are registered without the possibility of being altered in the future. Certify the validity of the process.': 'It is the technology that ensures that the actions related to a byppay / factoring / endorsemeent are registered without the possibility of being altered in the future. Certify the validity of the process.',
    'MoreInfo.FAST, CHEAP & SAFE': 'FAST, CHEAP & SAFE',
    'MoreInfo.You pay your invoices by bypaying income directly to your providers. No cash, no funding are needed. The app uses DLT/Blockchain to secure the byppay agreements': 'ou pay your invoices by bypaying income directly to your providers. No cash, no funding are needed. The app uses DLT/Blockchain to secure the byppay agreements',
    'MoreInfo.HOW DOES IT WORK?': 'HOW DOES IT WORK?',
    'MoreInfo.Upload your providers and clients invoices into the app. The app will propose byppaying some invoices: When your clients pay directly to your providers, you have paid then indeed, and invoices compensated!': 'PUpload your providers and clients invoices into the app. The app will propose byppaying some invoices: When your clients pay directly to your providers, you have paid then indeed, and invoices compensated!!',
    'MoreInfo.A NEW NORMAL': 'A NEW NORMAL',
    'MoreInfo.Byppaying is the fastest, cheapest and safest funding in the market.': 'Byppay is the fastest, cheapest, and safest funding in the market',

    'ByppayList.No bypay has yet been initiated with this invoice.': 'No byppay has yet been initiated with this invoice.',

    'ItemListChat.REMAIN': "REMAIN",

    'AdminCommissions.Receiver comission': 'Receiver interest by delayed payment',
    'AdminCommissions.Platform comission': 'Platform fee',
    'AdminCommissions.Byppay Commision': 'Clients discount (bonus)',

    'CollateralModal.Add to list': 'Add to list',
    'CollateralModal.Minimum value to pay': 'Minimum amount to pay: ',
    'CollateralModal.Email list notification': 'List of the emails to notify the publications.The emails will be separated by commas',
    'Collateralmodal.MessagePublish': 'To publish the invoice you need to pay a minimum of {percentage} % of the invoice',

    'CollateralView.Anonymous': 'Anonymous',

    'AcceptBypayes.Approve byppayes': 'Aprove byppays',

    'NavigationMenu.Invoices to pay': 'Invoices to pay',
    'NavigationMenu.Invoices to be payed': 'Invoices to get pàid',
    'NavigationMenu.Clients': 'Clients',
    'NavigationMenu.Marketplace': 'Marketplace',
    'NavigationMenu.AMM': 'rkAMM',
    'NavigationMenu.Faq': 'FAQ',
    'NavigationMenu.Chat': 'Chat',

    'MainView.Min Date': 'Min Date',
    'MainView.Min-Max Amount': 'Min-Max Amount',
    'MainView.Introduce Min and Max Date': 'Introduce Mín and/or Max Dates',
    'MainView.To get paid': 'To get paid',
    'MainView.Error listing invoices': 'Error listing invoices',
    'Mainview.There are no invoices yet': 'There are no invoices yet',
    'MainView.Failed': 'Failed',
    'MainView.Advanced Options': 'Advanced Options',
    'MainView.Reset': 'Reset',
    'MainView.Filter': 'Filter',
    'MainView.Archived': 'Archived',

    'AcceptBypaymentChatComponent.Decline': 'Reject',

    'VideoInput.Record Video': 'Gravar Video',

    'ItemListChat.Receive': 'Receive',
    'ItemListChat.Invited': 'Invited',

    'InviteChatForm.Send MAIL': 'Send EMAIL',
    'InviteChatForm.Send SMS': 'Send SMS',
    'InviteChatForm.Send Whatsapp': 'Send WhatsApp',
    'InviteChatForm.InviteEmail': 'Invite by mail',
    'InviteChatForm.InvitePhone': 'Invite by phone',

    'AddInvoiceToChat.AddInvoice': 'Add invoice',

    'Invoice': 'Factura',
    'ItemMessageFormInvite.Invite': 'Invite',
    'AllFilesChat.with': 'with',
    'chat.newChat': 'Welcome message',
    'chat.newChatExtra': 'This is the welcome video and a link to the first steps to byppay',
    'chat.remindInvite': 'Remind Invite',

    'chat.inviteDownStream': '{user} has invited {userInvited}. Waiting for {userInvited} to accept',
    'chat.inviteDownStreamExtra': '{userInvited} has to accept the invitation and join the chat. \n If he doesn\'t accept then you might send a reminder to join the chat',
    'chat.inviteUpStream': '{user} has invited {userInvited}. Waiting for {userInvited} to accept (byppay)',
    'chat.inviteUpStreamExtra': '{userInvited} has to accept the invitation and join the chat. \n EIf he doesn\'t accept then you might send a reminder to join the chat',

    'chat.enterDownStream': '{user} has joined the chat (invoice)',
    'chat.enterDownStreamExtra': '{payerUser} has to upload the {user} \'s invoice ',
    'chat.enterUpStream': '{user} has joined the chat (byppay)',
    'chat.enterUpStreamExtra': 'waiting to {user} to have paid the invoice',
    'chat.payed': '{user} has paid the invoice',
    'chat.payedExtra': '{user} has paid the invoice',
    'chat.acceptedByppay': '{user} has accepted the byppay',
    'chat.acceptedByppayExtra': 'Inviting the other byppay participant, is pending',
    'chat.rejectedByppay': '{user} has rejected the byppay',
    'chat.rejectedByppayExtra': '{user} has rejected thebyppay',
    'chat.byppayPayed': 'Byppay is paid',
    'chat.byppayPayedExtra': 'Byppay is paid',
    'chat.invoiceGenerated': 'Compensated invoice has been generated',
    'chat.invoiceGeneratedExtra': '{user} is the holder of the new invoice offset',
    'chat.acceptPaymentOutsidePlatform': 'Accept payment outside the platform',
    'chat.acceptPaymentOutsidePlatformExtra': 'Outplatform payment done and accepted; the byppay is finished',
    'chat.paymentOutsidePlatform': 'Payment outside the platform ',
    'chat.paymentOutsidePlatformExtra': 'The receiver of the payment must acknowledge the outplatform payment',
    'chat.ButtonAcceptPaymentOutsidePlatform': 'Accept payment outside the platform',
    'chat.newDate': '{day}/{month}/{year}',
    'cat.nopaymentmethods': 'There is no payment method declared',
    'chat.set-payment': '{user} has introduced payment methods',
    'chat.set-paymentExtra': 'Waiting for {payer} pay or byppay the invoice',
    'chat.see-invoice': 'See invoices',
    'chat.see-files': 'See files',
    'chat.edit-payment-info': 'Update means of payment information',
    'chat.view-contract': 'See contract',
    'chat.stipe-public-key': 'Stripe public key',
    'chat.stipe-private-key': 'Stripe private key',
    'chat.public-crypto-address': 'Crypto public address',

    'chat.remind-introduce-payment-methods': 'Remind to enter payment methods',
    'chat.remind-paymentMethodExtra': 'Waiting for (payer} to enter the payment methods',
    'chat.invoice-added': '{user} has added an invoice',
    'chat.invoice-addedExtra': 'Waiting that the receiver {receiver} enters his payment methods',
    'chat.byppay-added': '{user} has added a byppay',
    'chat.byppay-addedExtra': 'Waiting for {receiver} to acknowledge the payment',
    'chat.remind-to-payExtra': '{user} sends a kindly payment reminder to {payer}',
    'chat.noInvoiceInChat': 'There is no invoice in the chat yet',
    'chat.remind-join-chat': 'Remind join chat',
    'chat.insertMessage': 'Must compose a message',
    'chat.insertFile': 'Must attach a file',
    'chat.archive-chat': 'Archive the chat',
    'chat.unarchive-chat': 'Unarchive the xat',
    'chat.add-to-calendar': 'Add payment to the Calendar',
    'Chat.helpCenter': 'Help Center',
    'Chat.Message': 'Message',
    'Chat.errorMessageHelp': 'Error get help message',

    'PaymentInformationBytton.AddPaymentMethod': 'Enter payment methods',

    'allFiles.files-in-invoice': 'Invoice Files',
    'invoice.go-to-chat': 'Go to chat',
    'invoice.acrhive': 'Archive',
    'invoice.archived': 'Unarchive',
    'Invoice.Go Back': 'Back',
    'Invoice.Invoice Detail': 'Invoice Details',

    'createInvoice.nifReceiver': 'Receiver VAT num. ',
    'createInvoice.nifPayer': 'Payer VAT num.',

    'Login.LogoutUnregisteredUser': 'Close the sessio as unlogged user',
    'Login.Forgot Password?': 'Forgot your Password?',
    'Login.New to Byppay?': 'New to Byppay? ',
    'Login.Reset the Password!': 'Reset the password!',
    'Login.Send email': 'Send email',
    'Login.Change the Password!': 'Change the password!',
    'Login.New Password': 'ew password',
    'Login.New Password Confirmation': 'New passwords confirmation',
    'Login.Change password': 'Change the password',
    'Login.Logged out succesfully!': 'Session logged out successfully',
    'Login.ERROR: Invalid token, check again the URL on your e-mail': 'ERROR: Token invàlid, check again your emai for the right URL',
    'Login.ERROR: You are already validated': 'ERROR: you are already validated',
    'Login.You let empty params, check it again please': 'You left empty params; check it again please',
    'Login.Logged successfully!': 'Session logged successfully!',
    'Login.Check your email in order to reset the password': 'Check your email to reset the password',
    'Login.Error: Cannot send an email to reset you password. Please check the email you enter.': 'Error: Cannot send an email to reset you password. Please check the email you entered.',
    'Login.You can now log in': 'You can now log in',
    'Login.Passwords doesn\'t match': 'Passwords don\'t match',
    'Login.Register': 'Sign up',
    'Login.ERROR: Missing fields on the formulary': 'Missing fields, in the form',
    'Login.ERROR: User not found': 'ERROR: User not found',
    'Login.ERROR: Wrong password': 'ERROR: worng password',
    'Login.ERROR: User is not validated': 'ERROR: User is not validated',
    'Login.about': 'About Byppay',
    'Login.LanguageTitle': 'Choose your language',

    'Register.Your Name': 'Your name',
    'Register.Use 6 characters with a mix of letters, numbers & symbols': 'Use 6 characters with a mix of letters, numbers & symbols',
    'Register.Registered succesfully! Please check your email for the validation': 'Registered succesfully! Please check your email for the validation',
    'Register.ERROR: The user couldn\'t be saved': 'ERROR: The user couldn\'t be saved',
    'Register.ERROR: E-mail already in use': 'ERROR: the email already is in use',
    'Register.ERROR: CiF already in use': 'ERROR: El VAT number is already in use',
    'Register.By signing up, you agree to Byppay of Use & Privacy Policy': 'By registering you are accepting our',
    'Register.Policy': 'Use and Privacy policies',
    'Register.Already signed up? ': 'Already signed up? ',
    'RegisterLayout.Title': 'Please fill out the form',
    'AllFilesChat.notImages': 'There is no imaged in the chat, yet',
    'AllFilesChat.pdfs': 'There is no PDF in the chat, yet',
    'AllFilesChat.images': 'Images',
    'AllFilesChat.head': 'Files in the chat ',
    'AllFilesChat.headGroup': 'Files in the group',
    'chat.pdf': 'See byppay contract',
    'chat.download': 'Download byppay contract as PDF',

    'BrowseScroll.head': 'Invoice number',
    'BrowseScroll.undefined': 'undefined',
    'BrowseScroll.DATA': 'DATA',

    'Button.accept': 'Accept',

    'InvoiceChats.registeredError': 'You must have logged in to use this function.',
    'invoiceChats.Archived': 'See archived chats',
    'InvoiceChatsArchived.noChats': 'There is no archived chat yet',
    'InvoiceChatsArchived.returnToChats': 'Back to the chats',
    'InvoiceChatsArchived.head': 'These chats are archived now. To unarchived them, enter the chat zone',
    'InvoiceChats.MessagePresentation': 'Byppay message presentation',


    'InvoiceChats.Foto': 'Photo',

    'Notifications.Notification List': 'Notifications list',
    'Notifications.Error get notifications': 'Error in getting the notifications',

    'AllInvoicesChat.headGroup': 'List of invoices in the chat',

    'Profile.Logged out succesfully!': 'Session logged off!',
    'Profile.Profile': 'Profile',
    'Profile.Name': 'Name',
    'Profile.Surname': 'Last Name',
    'Profile.Address': 'Address',
    'Profile.Country': 'Country',
    'Profile.Wallet Address': 'Wallet address',
    'Profile.Exange ratios': 'Exchange fees',
    'Profile.Euro to byto ratio': 'Euro to byto conversion',
    'Profile.Platform amount': 'Platform total amount',
    'Profile.Don\'t show the splash screen at the beggining': 'Don\'t show the splash screen at the beginning',
    'Profile.Do you want to logout?': 'Do you want to logout?',
    'Profile.Payer comission': 'Payer Delayed Payment interest',
    'Profile.My profile': 'My profile',

    'Create.Invoices': 'Invoices:',
    'Create.Status': 'Status',
    'Create.days': 'days',
    'Create.Invoice deleted successfully!': 'invoice deleted successfully',
    'Create.Error deleting the invoice': 'Error deleting invoice',

    'InvoiceStatus.Payed': 'Paid',
    'InvoiceStatus.Pending': 'Pending',
    'InvoiceStatus.Unpayed': 'Unpaid',
    'InvoiceStatus.Charged': 'Got paid',
    'InvoiceStatus.Created': 'Created',
    'InvoiceStatus.Compensated': 'Compensated',
    'InvoiceStatus.Temporary': 'Temporary',
    'InvoiceStatus.Unknown': 'Unknown',
    'InvoiceStatus.ERROR: Cannot get blockChain data': 'ERROR: Cannot get blockChain data',

    'InvoiceInformation.BlockChain Information': 'BlockChain information',
    'InvoiceInformation.Basic Information': 'Basic Information',
    'InvoiceInformation.Link to Blockchain': 'Link to the BlockChain',
    'InvoiceInformation.Blockchain Amount': 'BlockChain Amount',
    'InvoiceInformation.Blockchain Date': 'BlockChain Date',
    'InvoiceInformation.Blockchain Status': 'Blockchain Status',
    'InvoiceInformation.BlockChain': 'Blockchain',
    'InvoiceInformation.See transaction': 'See transaction',
    'InvoiceInformation.There is no data for this invoice stored on the Blockchain.': 'There is no data for this invoice, stored on the Blockchain.',

    'CreateInvoiceModal.NEW INVOICE': 'NEW INVOICE',
    'CreateInvoiceModal.MODIFY INVOICE': 'MODIFY INVOICE',

    'SpecificCompensation.Pending Compensations': 'Pending Compensations',

    'Bypaysummary.Compensated': 'Compensated',

    'SmallInvoce.Me': 'Me',

    'FactoringLogic.Petition modified successfully!': 'Petition modified successfully!',

    'PendingFactoringItem.Do you want to accept this bypay?': 'Do you want to accept this byppay?',
    'PendingFactoringItem.Petition accepted successfully!': 'Petition accepted successfully!!',
    'PendingFactoringItem.USER NOT LOGGED!': 'User not logged - Welcome to byppay',
    'PendingFactoringItem.You are not logged into the platform, please login or register to perform some action': 'You are not logged in the platform, please do it to perform any action',

    'SuggestedFactoringItem.DESTINY EMAILS': 'E-MAILS DESTINATION',
    'SuggestedFactoringItem.Do you want to propose your partners this bypay?': 'Do you want to propose this byppay to the client and the provider?',
    'SuggestedFactoringItem.already exists, use another email!': ' already exists, use another email!',
    'SuggestedFactoringItem.Are you sure?': 'Are you sure?',
    'SuggestedFactoringItem.Do you want to decline this bypay proposal?': 'Are you sure you reject this byppay proposal?',
    'SuggestedFactoringItem.The platform suggests you to perform the following compensation:': 'The platform suggests you to perform the following compensation',

    'InvoiceMissingInformation.Payer CIF': 'VAT number of the payer',
    'InvoiceMissingInformation.Payer email:': 'Email of the payer',
    'InvoiceMissingInformation.Payer email': 'Email of the payer',
    'InvoiceMissingInformation.Receiver CIF': 'VAT number of the receiver',
    'InvoiceMissingInformation.Receiver email': 'Email of the receiver',
    'InvoiceMissingInformation.Receiver NIF/CIF, Mail & name': 'VAT number, email & name of the receiver',
    'InvoiceMissingInformation.Payer NIF/CIF, Mail & name': 'VAT number, email & name of the payer',
    'InvoiceMissingInformation.Account number:': 'Account number:',
    'InvoiceMissingInformation.Update': 'Update',

    'MyInvoices.PublishAMM': 'Do you want to publish this byppay to the rkAMM and get this amount in advance?',
    'MyInvoices.CollectByppay': 'Collect byppay',
    'AmmModal.MessageInformation': 'To be able to get the byppay amount trhought the rkAMM you need to  pay a premium with a cost of:',
    'AmmModal.ValueToPay': 'Value to pay',

    'Help.HELP': 'HELP',
    'Help.Forward': 'Es realitza Forward',
    'Help.when you propose your providers if they want to be paid directly from your clients.': 'quan proposis als teus proveïdors si volen ser pagats directament pels teus clients',
    'Help.Bypay': 'Es realitza Byppay',
    'Help.when you ask your clients to pay your providers or when you want any client of your client to pay directly': 'quan proposis als teus clients pagar als teus proveïdors o bé quan vulguis que qualsevol client dels teus clients et pagui directament',
    'Help.If you are owner of a small business or self-employed': 'Si ets propietari d\'un petit negoci o autònom',
    'Help.Bypaying and forwarding invoices saves valuable cash and cash-in time, frees you from bank loans, and enhances your scoring': 'Fer Byppay o Forward de factures t\'estalvia temps i diners en efectiu, t\'allibera de préstecs bancaris i millora el teu scoring bancari',
    'Help.It is way cheaper than banks, safer, faster, and requires no burocracy thanks to the blockchain technology': 'És menys costós que els bancs, més segur, més ràpid i no té burocràcia gràcies a la tecnologia Blockchain',
    'Help.Try it! Byppay': 'Try it! Byppay',

    "EditableSystemMessages.Save Tag": "Saved",

    "faucet.AddFunds": "Add funds",

    'Amount:': 'Amount:',

    'Error.Error deleting bypay': 'Error deleting a byppay',
    'Error.Error accepting petition': 'Error in accepting the petition',
    'Error.Error modifying petition': 'Error in modifying the petition',
    'Error.The mail field is required': 'The email field is mandatoryi',
    'Error.Error rejecting petition': 'Error rejecting petition',
    'Error.This field is required': 'This field is mandatory',
    'Error.The CIF must be different than yours.': 'The VAT number must be different from yours.',
    'Error.The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)': 'El VAT number has to be in a valid format (Example: A12345678, 12345678B, C1234567D)',

    'Success.Bypay deleted successfully!': 'The byppay is deleted',
    'RelatedInvoice': 'Related invoice',
    'error.NoMoney': 'You lack funds for the payment.',
    'error.NoMoney.Faucet': 'Go to the faucet',
    'error.NoWallet': 'You have no cryptowallet in your setup.',
    'error.NoWallet.Video': 'Go to the explanatory video',
    'tutorial.welcomeToByppay': 'Welcome to Byppay!',
    'tutorial.Tell': 'Let’s tell you all about the functionality.',
    'tutorial.discoverbtn': 'Discover \n how to use',
    'tutorial.skipbtn': 'Skip tutorial',
    'tutorial.text1': 'The explanations will be available to you at all times to help you along the way.',
    'tutorial.text2': 'Watch this video to have a better sense of the next steps to take.',
    'tutorial.nextbtn': 'Next',
    'tutorial.text3': 'Byppay is a webapp that allows you to pay invoices 4 times cheaper and x10 faster.',
    'tutorial.text4': 'Watch this video to learn about the navigation within the app.',
    'tutorial.text5': 'Byppay allows you to pay, byppay, or get paid on your invoices, depending on your situation.',
    'tutorial.text6': 'If you want to learn more about the client’s point of view, click ‘”I want to pay my invoices”.',
    'tutorial.text65': 'If you want to learn more about the client’s point of view, click ‘”I want to get paid on my invoices”.',
    'tutorial.text7': 'If you want to get paid on your outstanding invoices, watch this video to get a better understanding of the supplier’s point of view.',
    'tutorial.text8': 'If you want to pay or byppay  your outstanding invoices, watch this video to get a better understanding of the client’s or contractor’s point of view.',
    'tutorial.paybtn': 'I want to pay my invoices',
    'tutorial.getpaidbtn': 'I want to get paid on my invoices',
    'tutorial.endtutorial': 'End tutorial',

    'Popup.verify': 'Verify your account',
    'Formulary.AddContact': 'Add contact',
    'Formulary.ChooseAContact': 'Choose contact',
    'Formulary.Contact Name': 'Name',
    'Formulary.Contact NIF/CIF': 'NIF/CIF',
    'Formulary.Contact Email': 'Email',
    'Formulary.Contact phone': 'Phone',

    'Working.onIt' : 'Working on it!',
    'We.areWorking' : 'we are working on this feature!'

};
